const buildQuery = (params) => {
    const query = new URLSearchParams(params);

    return query.toString();
};


export {buildQuery};